import {action, makeObservable, observable} from 'mobx';

export enum NotificationType {
    success = 'success',
    error = 'error'
}

type Params = {
    msg: string;
    type: NotificationType | null;
    show: boolean;
};

class BPMMsgNotification {
    @observable params: Params = {
        msg: '',
        type: null,
        show: false
    };
    timer: NodeJS.Timer | null = null;

    constructor() {
        makeObservable(this);
    }

    @action
    showMsg = (msg: string, type: NotificationType, timerDuration: number = 3000) => {
        this.params = {
            msg,
            type,
            show: true
        };

        if (this.timer) clearTimeout(this.timer);

        this.timer = setTimeout(() => {
            this.hideMsg();
        }, timerDuration);
    };

    @action
    hideMsg = () => {
        this.params = {
            msg: '',
            type: null,
            show: false
        };
    };
}

export const bpmMsgNotificationStore = new BPMMsgNotification();
